import React from 'react';
import { Stack, Text } from '@atlaskit/primitives';
import { useIntl } from '@atlassian/jira-intl';
import { Link } from '@atlassian/react-resource-router';
import messages from './messages';

const InfoPopupContent = () => {
	const { formatMessage } = useIntl();
	return (
		<Stack space="space.150">
			<Text as="p">{formatMessage(messages.infoMessage)}</Text>
			<Text as="p">
				<Link
					target="_blank"
					href="https://support.atlassian.com/jira-software-cloud/docs/edit-a-projects-details/"
				>
					{formatMessage(messages.infoLink)}
				</Link>
			</Text>
		</Stack>
	);
};

export default InfoPopupContent;
